import type { SxProps, Theme } from '@mui/material';
import { axisClasses } from '@mui/x-charts/ChartsAxis';

export const REPORT_CHART_COLORS = Object.freeze({
  new: '#9c80ff',
  expansion: '#42ae5c',
  contraction: '#fbdeae',
  churn: '#ff7c94',
  reactivation: '#7dd3ae',
  endingMrr: '#2953ff',
  recognized: '#5083ff',
  deferred: '#42AE5C',
  unbilled: '#7e8796',
  newDeferred: '#2953ff',
  adjustments: '#ff7c94',
  beginning: '#6b7785',
  ending: '#1a2332',
} as const);

export const REPORT_CHART_FONT = Object.freeze({
  family: "'Inter', sans-serif",
  size: 14,
  weight: 400,
  color: '#2d3949',
} as const);

const AXIS_LABEL_STYLE = {
  fontFamily: REPORT_CHART_FONT.family,
  fontSize: REPORT_CHART_FONT.size,
  fontWeight: REPORT_CHART_FONT.weight,
  fill: REPORT_CHART_FONT.color,
} as const;

export const REPORT_CHART_TICK_LABEL_STYLE = AXIS_LABEL_STYLE;
export const REPORT_CHART_AXIS_LABEL_STYLE = AXIS_LABEL_STYLE;

export const REPORT_CHART_AXIS_HIDE_SX: SxProps<Theme> = {
  [`.${axisClasses.root}`]: {
    [`.${axisClasses.tick}, .${axisClasses.line}`]: {
      stroke: 'none',
    },
  },
};

export const REPORT_CARD_SX: SxProps<Theme> = {
  borderRadius: '10px',
  border: '1px solid #e8ebf2',
  backgroundColor: '#f5f6fa',
  px: '24px',
  py: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};
